<template>
	<div class="progress-item">
		<div>
			<div>个人</div>
			<div class="val">
				<div class="value">30</div>
				<div class="rate">32.5%</div>
			</div>
			<div>
				<el-progress :percentage="32.5" :stroke-width="6" color="#4080FF" :show-text="false"></el-progress>
			</div>
		</div>
		<div>
			<div>其他</div>
			<div class="val">
				<div class="value">34</div>
				<div class="rate">67.5%</div>
			</div>
			<div>
				<el-progress :percentage="67.5" :stroke-width="6" color="#4080FF" :show-text="false"></el-progress>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ProgressChart',
		props: {
			categories: {
				type: Array,
				default: () => [],
			},
		},
		computed: {
			// total() {
			// 	return this.categories.reduce((sum, item) => sum + item.value, 0);
			// },
		},
		methods: {},
	};
</script>

<style lang="scss" scoped>
	.progress-item {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: 20px;
		color: #414755;
		font-size: 10px;
		font-weight: bold;
	}
	.val {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 4px;
	}
	.value {
		font-size: 24px;
	}
	.rate {
		color: #414755;
		font-size: 12px;
		font-weight: 400;
	}
</style>
